export const RESET_WAITING_LIST_CUSTOMERS = 'RESET_WAITING_LIST_CUSTOMERS';
export const FETCH_WAITING_LIST_CUSTOMERS = 'FETCH_WAITING_LIST_CUSTOMERS';
export const FETCH_WAITING_LIST_CUSTOMERS_SUCCESS = 'FETCH_WAITING_LIST_CUSTOMERS_SUCCESS';
export const FETCH_WAITING_LIST_CUSTOMERS_ERROR = 'FETCH_WAITING_LIST_CUSTOMERS_ERROR';
